import { SerializableObject } from '../../common-react/core';

import { Currency } from '../other/currency.type';
import { ShipmentDeliveryServiceId } from '../other/shipment-delivery-service-id.enum';
import { ShipmentType } from '../other/shipment-type.enum';

import { Label } from './label.do';
import { ShipmentDeliveryServiceExtra } from './shipment-delivery-service-extra.do';

/**
 * @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.ShipmentDeliveryService
 */
export class ShipmentDeliveryService extends SerializableObject {
  public id: ShipmentDeliveryServiceId;
  /**
   * A sting describing the estimated delivery, e.g. "2-4 workdays".
   */
  public estimatedDeliveryMessage: string;
  public deliveryLocationIsRequired?: boolean;
  public priceAmount?: number;
  public priceCurrency?: Currency;
  public includesServiceFragile?: boolean;
  public includesServiceHomeDelivery?: boolean;
  public extraServices?: ShipmentDeliveryServiceExtra[];
  public deliveryLocations?: Location[];
  public type: ShipmentType;
  public labels: Label[];


  public getStartingPrice(): number {
    return this.priceAmount || 0;
  }

  public getTotalPrice(): number {
    return this.getStartingPrice() + this.getSelectedExtraServicesPrice();
  }

  public getSelectedExtraServicesPrice(): number {
    if (!this.extraServices || this.extraServices.length === 0) {
      return 0;
    }
    let total = 0;
    this.extraServices.forEach((value: ShipmentDeliveryServiceExtra): void => {
      if (value.includedInService) {
        total += value.priceAmount;
      }
    });
    return total;
  }

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'extraServices':
        if (!propertyValue) {
          return [];
        }
        const extraServices: ShipmentDeliveryServiceExtra[] = [];
        (propertyValue as unknown[]).forEach((partialData: unknown): void => {
          extraServices.push(new ShipmentDeliveryServiceExtra(partialData));
        });
        return extraServices;

      case 'labels':
        if (!propertyValue || !Array.isArray(propertyValue)) {
          return [];
        }
        return propertyValue.map((value): Label => {
          return new Label(value);
        });

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

}
